import React from "react";

import { css } from "@emotion/react";

import { CSS_MQ } from "../../styles/breakpoints";
import { CSS_COLORS } from "../../styles/styles-css-variables";
import { FONTS, fontSize } from "../../styles/fonts";
import { comparisonIconForGroup } from "./comparison-icon-for-group";
import { type TranslatedValue } from "@swo/storefront";
import { T } from "../../components/T";

export const TechnicalSpecificationAttributeHeadline: React.FC<{
  groupKey: string;
  label: string | TranslatedValue;
}> = props => {
  const Icon = comparisonIconForGroup(props.groupKey);

  return (
    <>
      <Icon
        css={css`
          display: block;
          color: black;

          width: 40px;
          height: 40px;
          ${CSS_MQ.atLeastMd} {
            width: 55px;
            height: 55px;
          }
        `}
      />
      <span
        css={[
          FONTS.SwarovskiFutura500,
          fontSize.x2,
          css`
            color: ${CSS_COLORS.Green};

            text-transform: uppercase;
            text-align: center;

            margin-top: 12px;
            ${CSS_MQ.atLeastMd} {
              margin-top: 20px;
            }
          `,
        ]}
      >
        <T>{props.label}</T>
      </span>

      <hr
        css={css`
          width: 100%;
          height: 1px;

          margin-top: 20px;
          margin-bottom: 20px;
        `}
      />
    </>
  );
};
